module.exports = __webpack_public_path__ + "img/outpatientDepartment.cdb4759a.svg";